import Logo from "../common/logo";
import MenuPrincipal from "./menu-principal";
import SectionPage from "@/components/common/section-page";
import {GtLanguages} from "@/components/common/gt-languages/gt-languages";

export default function HeaderSiteOfficiel() {
    return <header className="px-6 py-2 gap-8">
        <SectionPage className={"flex items-center justify-between"} sectionType={"2xl"}>
            <Logo />
            <MenuPrincipal />
            <GtLanguages />
        </SectionPage>
    </header>;
}
